export enum MESSAGE_STATUS {
  PENDING = 1,
  SEND = 2,
  RECIVED = 3,
  READ = 4,
}
export interface Search {
  size: number,
  cursors: { [key: string]: Date }
}
export interface User {
  user: string;
  name: string;
  img?: string;
}
export interface Message {
  id?: string;
  date: Date;
  body: string;
  attachments: Attachment[];
  from: User;
  status: MESSAGE_STATUS;
}
export interface Attachment {
  key: string;
  url: string;
  contentType: string;
  size: number;
  fileName: string;
}
export interface Conversation {
  id: string;
  name: string;
  members: User[];
  lastSend: Message;
  messages: Message[];
  isGroup: boolean;
}
export interface ReciveNewMessage {
  conversation: string;
  message: Message;
}
